import crypto, { BinaryLike } from 'crypto';

interface Response {
  cipher: string;
  iv: string;
  tag: string;
}

const SECRET_KEY = crypto
  .createHash('sha256')
  .update(process.env.NEXT_PUBLIC_ENCRYPTION_CONNECT_WALLET_KEY as BinaryLike)
  .digest();
export type { Response as EncryptWalletResponse };
export default function useEncryptWalletRequest(address: string): Response {
  const payload = {
    address,
    timestamp: Date.now(),
  };

  const jsonPayload = JSON.stringify(payload);

  const iv = crypto.randomBytes(12);

  const cipher = crypto.createCipheriv(
    'aes-256-gcm',
    SECRET_KEY as Uint8Array,
    iv as Uint8Array
  );

  let encrypted = cipher.update(jsonPayload, 'utf8', 'base64');

  encrypted += cipher.final('base64');

  const authTag = cipher.getAuthTag();

  return {
    cipher: encrypted,
    iv: iv.toString('base64'),
    tag: authTag.toString('base64'),
  };
}
